<script setup lang="ts">
import Button from 'primevue/button';
import { useAppMenuItemsStore } from '../stores/app-menu-items';
import { useAppLayoutStateStore } from '../stores/app-layout-state';
import AppSidebar from './AppSidebar.vue';
import { useAppConfigStore } from '../stores/app-config-store';
import { useRouter } from 'vue-router';

const { push } = useRouter();

const stateStore = useAppLayoutStateStore();
const menuItemsStore = useAppMenuItemsStore();
const configStore = useAppConfigStore();

function navigateToHelp() {
    push({ name: 'help' });
}

function navigateToHelpGINO() {
    window.open(
        'https://www.precon-food.nl/wp-content/uploads/gino-instructie-voor-gebruikers.pdf',
        '_blank'
    );
}
</script>

<template>
    <div id="layout-topbar" class="layout-topbar">
        <div class="topbar-start">
            <Button
                v-if="menuItemsStore.hasItems"
                ref="menubutton"
                type="button"
                class="topbar-menubutton p-button-text p-trigger transition-duration-300"
                @click="stateStore.toggleMenu()"
            >
                <i class="pi pi-bars" />
            </Button>
        </div>

        <div class="layout-topbar-menu-section">
            <AppSidebar />
        </div>

        <div class="topbar-end">
            <ul class="topbar-menu">
                <template v-if="$layout.userProfileComponent">
                    <component :is="$layout.userProfileComponent" />
                </template>
                <li
                    class="app-layout-topbar-config-sidebar-toggle flex admin-help"
                >
                    <Button
                        v-tooltip.bottom="'Admin Portal Manual'"
                        text
                        icon="pi pi-question-circle"
                        class="p-button-text p-button-secondary flex-shrink-0"
                        @click="navigateToHelp()"
                    />
                </li>
                <li
                    class="app-layout-topbar-config-sidebar-toggle flex gino-help"
                >
                    <Button
                        v-tooltip.bottom="'GINO Manual'"
                        text
                        icon="pi pi-question-circle"
                        class="p-button-text p-button-secondary flex-shrink-0"
                        @click="navigateToHelpGINO()"
                    />
                </li>
                <li
                    v-if="configStore.topbarConfigToggle"
                    class="app-layout-topbar-config-sidebar-toggle"
                >
                    <Button
                        type="button"
                        icon="pi pi-cog"
                        class="p-button-text p-button-secondary flex-shrink-0"
                        @click="stateStore.showConfigSidebar()"
                    />
                </li>
                <li class="app-layout-topbar-right-menu-toggle">
                    <Button
                        type="button"
                        icon="pi pi-arrow-left"
                        class="p-button-text p-button-secondary flex-shrink-0"
                        @click="stateStore.showSidebar()"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>
